import { SANKEY_NODE_GAP } from "../sankeyLayout";
import type { ChartContext } from "./context";

export function buildSankeyOption(
  context: ChartContext,
): Record<string, unknown> {
  const { spec, data, isDark, translateNode, unitText, palette, ct, base } =
    context;
  const links = data.links ?? [];
  const nodeNames = [...new Set(links.flatMap((l) => [l.source, l.target]))];
  const top = spec.showTitle === false ? 8 : 55;
  const bottom = 12;
  const nodeGap = SANKEY_NODE_GAP;

  return {
    ...base,
    tooltip: {
      trigger: "item",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (params: {
        dataType: string;
        name: string;
        value: number;
        data?: { source?: string; target?: string };
      }) => {
        if (
          params.dataType === "edge" &&
          params.data?.source &&
          params.data.target
        ) {
          return `${translateNode(params.data.source)} > ${translateNode(params.data.target)}: ${unitText(params.value)}`;
        }
        return translateNode(params.name) + ": " + unitText(params.value);
      },
    },
    series: [
      {
        type: "sankey",
        left: 12,
        right: 156,
        top,
        bottom,
        layoutIterations: 64,
        nodeAlign: "justify",
        nodeGap,
        nodeWidth: 14,
        data: nodeNames.map((name) => ({
          name,
          itemStyle: { color: data.nodeColors?.[name] ?? palette[0] },
        })),
        links: links.map((l) => ({
          source: l.source,
          target: l.target,
          value: l.value,
        })),
        label: {
          show: true,
          formatter: (params: { name: string }) => translateNode(params.name),
          color: ct.color,
          fontSize: 12,
          width: 144,
          overflow: "truncate",
        },
        lineStyle: {
          curveness: 0.5,
          color: "source",
          opacity: data.sankeyLineOpacity ?? (isDark ? 0.3 : 0.32),
        },
        emphasis: {
          focus: "adjacency" as const,
          lineStyle: { opacity: 0.5 },
        },
      },
    ],
  };
}
